module.exports = __webpack_public_path__ + "img/logo_s.579e9e77.svg";